/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

require('bootstrap/js/dist/modal'); //Be sito Jqery neatirado modalo :O
require('jquery-ui/ui/widgets/datepicker.js');
require('jquery-ui/ui/widgets/draggable.js');
require('jquery-ui/ui/widgets/droppable.js');

require('vue-select');

require('datatables.net-buttons/js/dataTables.buttons.min.js');
require('datatables.net-buttons/js/buttons.html5.min.js');
require('datatables.net-buttons/js/buttons.print.min.js');

window.Vue = require('vue').default;


/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

// Vue.component('example-component', require('./components/ExampleComponent.vue').default);
// Vue.component('equipment-component', require('./components/NewEquipment.vue').default);
// Vue.component('new-customer-component', require ('./components/NewCustomer.vue'));
/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */
import NewCustomer from './components/NewCustomer';
import NewOffer from './components/NewOffer';
import NewSub from './components/NewSub';
import NewEquipment from './components/NewEquipment.vue';
import NewEquipmentType from './components/NewEquipmentType.vue';
import NewComment from './components/NewComment';
import EditOfferPrice from './components/EditOfferPrice';
import NewSales from './components/NewSales';
import EditSale from './components/EditSale';
import EditSub from './components/EditSub';
import NewEvent from './components/NewEvent';
import CustomerSearch from './components/CustomerSearch';
import SignPad from './components/SignPad';
import RivileSearch from './components/RivileSearch';
import Inspection from "./components/Inspection.vue";


const app = new Vue({
    el: '#app',
    components: {
        NewCustomer,
        NewOffer,
        NewEquipment,
        NewEquipmentType,
        NewComment,
        EditOfferPrice,
        NewSales,
        EditSale,
        NewSub,
        EditSub,
        NewEvent,
        CustomerSearch,
        SignPad,
        RivileSearch,
        Inspection,
    },
    mounted() {

        var a_moths = ["Sausis", "Vasaris", "Kovas", "Balandis", "Gegužė", "Birželis", "Liepa", "Rugpjūtis", "Rugsėjis", "Spalis", "Lapkritis", "Gruodis"];
        var a_day_min = ["Sk", "Pr", "An", "Tr", "Kt", "Pn", "Še"];

        $.ajaxSetup({
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }
        });

        $.each($('#customers').find("tr"), function (i, v) {
            $(v).attr('hidden', false);
        });

        $('[data-toggle="tooltip"]').tooltip('update');

        $(".datepicker").datepicker({
                firstDay: 1,
                dateFormat: "yy-mm-dd",
                monthNames: a_moths,
                dayNamesMin: a_day_min,
                // showOn: "both"
                onSelect: function (dateText) {
                    let form = {};
                    let obj = this;
                    form.customer_id = $(this).data('customer_id');
                    form[$(this).data('field')] = this.value;

                    axios.post('/customer/' + form.customer_id, form).then(res => {
                        if (res.data == 'OK') {
                            $(obj).addClass('bg-success');
                        }
                    })
                }
            }
        );

        // dark mode
        const darkSwitch = document.getElementById('darkSwitch');
        window.addEventListener('load', () => {
            if (darkSwitch) {
                initTheme();
                darkSwitch.addEventListener('change', (event) => {
                    resetTheme();
                });
            }
        });

        function initTheme() {
            const darkThemeSelected =
                localStorage.getItem('darkSwitch') !== null &&
                localStorage.getItem('darkSwitch') === 'dark';
            darkSwitch.checked = darkThemeSelected;
            darkThemeSelected ? document.body.setAttribute('data-theme', 'dark') :
                document.body.removeAttribute('data-theme');
        }

        function resetTheme() {
            if (darkSwitch.checked) {
                document.body.setAttribute('data-theme', 'dark');
                localStorage.setItem('darkSwitch', 'dark');
            } else {
                document.body.removeAttribute('data-theme');
                localStorage.removeItem('darkSwitch');
            }
        }

        // end dark mode

        $('.copy_filter').click(function (e) {
            // navigator.clipboard.writeText(window.location.href);
            // console.log(window.location.href);
            // const copyText = window.location.href;
            // copyText[0].select();
            // document.execCommand("copy");
            console.log(e.target);
            $(e.target).text('Nukopijuota');
            var dummy = document.createElement('input'),
                text = window.location.href;

            document.body.appendChild(dummy);
            dummy.value = text;
            dummy.select();
            document.execCommand('copy');
            document.body.removeChild(dummy);

        });


        $('.file-rename').click(function (e) {
            let obj = e.target;
            var old = $(obj).html();
            $(obj).closest('div').find('a').hide();
            console.log(old);

            let input = $("<input>").val(old).addClass('form-control');
            let maps = $($(obj).closest('div').find('[data-map]')).data('map');
            console.log(maps);
            $(input).val($(obj).data('val'));
            $(obj).html(input);
            $(input).focus();

            $(input).keydown(function (e) {

                if (e.keyCode === 13) {
                    e.preventDefault();
                    let map = maps.split('|');

                    map[4] = $(e.target).val();


                    console.log(map);
                    axios.post('/file_rename', map).then(res => {
                        console.log(res.data);
                        if (res.data === 'OK') {
                            window.location.reload();
                        }
                    })
                }
            });


        });


        let o_touchtime = 0;
        $('.one_double').click(function () {
            console.log('f_onedouble');
            if (o_touchtime == 0) {
                // set first click
                o_touchtime = new Date().getTime();
                $(this).click();
            } else {
                // compare first click to this click and see if they occurred within double click threshold
                if (((new Date().getTime()) - o_touchtime) < 800) {
                    // double click occurred
                    o_touchtime = 0;
                } else {
                    // not a double click so set as a new first click
                    o_touchtime = new Date().getTime();
                    $(this).click();
                }
            }

        });


        let touchtime = 0;
        let i_touchtime = 0;
        $('.editable').click(function (e) { console.log('f_editable');

            if (touchtime == 0) {
                // set first click
                touchtime = new Date().getTime();
                return;
            } else {
                // compare first click to this click and see if they occurred within double click threshold
                if (((new Date().getTime()) - touchtime) < 800) {
                    // double click occurred
                    //alert("double clicked");
                    touchtime = 0;
                } else {
                    // not a double click so set as a new first click
                    touchtime = new Date().getTime();
                    return;
                }
            }

            let do_delete = false;
            let soft_delete = false;
            let obj = e.target;
            let old = $(obj).html();
            console.log(old);

            if ($(obj).prop('tagName') == 'INPUT') {
                let old = $(obj).val();
            }

            if ($(obj).data('value')) { //jei turime linka ar kazka panasaus langelyje
                old = $(obj).data('value');
            }


            $(obj).removeAttr('readonly').blur();

            let input = $("<input>").val(old).addClass('form-control');
            let maps = $($(obj).closest('[data-map]')).data('map');

            if (maps == 'delete') {
                do_delete = true;
            }
            if (maps == 'soft_delete') {
                soft_delete = true;
            }
            if ($(obj).closest('[data-key]').data('key') != null) {
                maps = $(obj).closest('[data-key]').data('key') + '|' + maps;
            }

            console.log('maps - ' + maps);

            //regular delete
            if (do_delete) {
                confirm('Ištrinti?')
                {
                    let map = maps.split('|');
                    axios.post('/ajax_delete', map).then(res => {
                        if (res.data === 'OK') {
                            window.location.reload();
                        }
                    })
                }
                return;
            }

            //soft delete
            if (soft_delete) {
                if(confirm('Archyvuoti / Atstatyti ?'))
                {
                    let map = maps.split('|');
                    axios.post('/ajax_delete', map).then(res => {
                        if (res.data === 'OK') {
                            window.location.reload();
                        }
                    })
                }
                return;
            }


            if ($(obj).data('value') && $(obj).prop('type') == 'checkbox') {
                console.log('chh');
                let map = maps.split('|');

                map[4] = (old === -1 ? 0 : old);
                axios.post('/ajax_update', map).then(res => {
                    if (res.data === 'OK') {
                        if(map[3] == 'no_apva') { window.location.reload(); }
                        if ($(obj).hasClass('custom-control-input')) {
                            if ($(obj).data('value') == -1) {
                                $(obj).data('value', 1);
                            } else {
                                $(obj).data('value', -1);
                            }
                        } else {
                            if ($(obj).data('value') == -1) {
                                $(obj).data('value', 1);
                                $(obj).prop("checked", false);
                            } else {
                                $(obj).data('value', -1);
                                $(obj).prop("checked", true);
                            }

                        }

                    }
                })
                return;
            }


            if ($(obj).data('select')) {
                let s_map = $(obj).data('select').split('|');
                if (s_map != null) {
                    axios.post('/ajax_get', s_map).then(res => {

                        var select = $('<SELECT>').addClass('form-control');
                        $(select).append('<option value="">Rinktis...</option>');
                        $.each(res.data, function (index, value) {
                            $(select).append('<option ' + (old == value.name ? 'selected' : '') + ' value="' + value.id + '">' + value.name + '</option>');
                        });

                        $(select).change(function () {
                            let map = maps.split('|');
                            map[4] = $(this).val();
                            axios.post('/ajax_update', map).then(res => {
                                if (res.data === 'OK') {
                                    if ($(obj).prop('tagName') == 'TD') {
                                        $(select).replaceWith($(select).find(":selected").text());
                                        $(obj).addClass('text-success');
                                    } else {
                                        $(obj).addClass('bg-success');
                                    }

                                    if ($(obj).prop('tagName') == 'INPUT') {
                                        $(select).replaceWith($(select).find(":selected").text());
                                        $(obj).attr('readonly', 'readonly');
                                    }
                                }
                            });
                            return false;
                        });

                        $(obj).html(select);
                    });
                }


            }


            if ($(obj).data('map') === 'start_date' && $(obj).data('value') === 0) {
                if (confirm('Ištrinti darbų datą?')) {
                    let map = maps.split('|');
                    axios.post('/ajax_update', map).then(res => {
                        if (res.data === 'OK') {
                            window.location.reload();
                        }
                    });
                }

                return;
            }

            if ($(obj).data('map') === 'offer_status_id' && $(obj).hasClass('one_double')) {
                let text = ''
                if($(obj).data('value') == 25){
                    text = 'Skubiai montuojam?';
                }
                if($(obj).data('value') == 26){
                    text = 'Montuojam?';
                }
                if($(obj).data('value') == 30){
                    text = 'Sumontuota?';
                }
                if (confirm(text)) {
                    let map = maps.split('|');
                    map[4] = $(obj).data('value');
                    axios.post('/ajax_update', map).then(res => {
                        if (res.data === 'OK') {
                            window.location.reload();
                        }
                    });
                }

                return;
            }

            if ($(obj).data('map').indexOf('date') > 0) {
                $(input).datepicker({
                        firstDay: 1,
                        dateFormat: "yy-mm-dd",
                        monthNames: a_moths,
                        dayNamesMin: a_day_min,
                        // showOn: "both"
                        onSelect: function (dateText) {
                            let map = maps.split('|');
                            map[4] = this.value;
                            axios.post('/ajax_update', map).then(res => {
                                if (res.data === 'OK') {

                                    $(obj).html(this.value);
                                    if ($(obj).prop('tagName') == 'TD') {
                                        $(obj).addClass('text-success');
                                    } else {
                                        $(obj).addClass('bg-success');
                                    }

                                    if ($(obj).prop('tagName') == 'INPUT') {
                                        $(obj).attr('readonly', 'readonly');
                                    }
                                }
                            })
                        }
                    }
                );

            }


            if ($(obj).prop('tagName') != 'INPUT') {
                $(obj).html(input);
                input.focus();
            } else {
                input = obj;
                $(input).blur();
            }

            $(input).focus();

            $(input).keydown(function (e) { console.log(e.keyCode);
                if (e.keyCode === 13) {
                    let map = maps.split('|');

                    map[4] = $(e.target).val();

                    //replace not unsuitable symbols
                    if ($(obj).data('tobereplaced') !== undefined) {
                        let repl = $(obj).data('tobereplaced').split('|');
                        map[4] = $(e.target).val().replace(repl[0], repl[1]);
                    }

                    axios.post('/ajax_update', map).then(res => {
                        if (res.data === 'OK') {

                            $(obj).html($(e.target).val());
                            if ($(obj).prop('tagName') == 'TD') {
                                $(obj).addClass('text-success');
                            } else {
                                $(obj).addClass('bg-success');
                            }

                            if ($(obj).prop('tagName') == 'INPUT') {
                                $(obj).attr('readonly', 'readonly');
                            }
                        }
                    })
                }
            }).click(function (e) {

                if (i_touchtime == 0) {
                    // set first click
                    i_touchtime = new Date().getTime();
                    return;
                } else {
                    // compare first click to this click and see if they occurred within double click threshold
                    if (((new Date().getTime()) - i_touchtime) < 800) {
                        // double click occurred
                        //alert("double clicked");
                        i_touchtime = 0;
                    } else {
                        // not a double click so set as a new first click
                        i_touchtime = new Date().getTime();
                        return;
                    }
                }

                let map = maps.split('|');

                map[4] = $(e.target).val();

                //replace not unsuitable symbols
                if ($(obj).data('tobereplaced') !== undefined) {
                    let repl = $(obj).data('tobereplaced').split('|');
                    map[4] = $(e.target).val().replace(repl[0], repl[1]);
                }

                axios.post('/ajax_update', map).then(res => {
                    if (res.data === 'OK') {

                        $(obj).html($(e.target).val());
                        if ($(obj).prop('tagName') == 'TD') {
                            $(obj).addClass('text-success');
                        } else {
                            $(obj).addClass('bg-success');
                        }

                        if ($(obj).prop('tagName') == 'INPUT') {
                            $(obj).attr('readonly', 'readonly');
                        }
                    }
                })
            });
        });

        // $(document).ready( function () {
        //     if($('#customers')){


        var table = $('#customers').DataTable({
            dom: 'lBfrtip',
            buttons: [
                {
                    exportOptions: {
                        columns: ':not(.hidden-col)',
                        rows: ':not(.no-export)',
                    },
                    "extend": "excel",
                    customize: function ( win ) {
                        console.log('HELLO!');
                    }
                },
                {
                    exportOptions: {
                        columns: ':not(.hidden-col)',
                        rows: ':not(.no-export)',
                        format: {
                            // body: function(data, column, row) {
                            //     console.log(data);
                            //     $(data).find('.no-export').remove();
                            //     DO SOMETHING WITH DATA
                                // return data;
                            // },

                        }
                    },
                    "extend": "print",
                    customize: function(win) {
                        console.log('HELLO!');
                        $(win.document.body).find('.no-export').remove();
                    }
                }
            ],
            "lengthMenu": [50, 150, 500],
            "orderMulti": false,
            "autoWidth": false,
            "ordering": true,
            "stateSave": true
        });

        table.column(1).visible(true);
        table.column(12).visible(false);
        table.column(12).order('asc');
        table.columns.adjust().draw();


        $('.customers_report').click(function () {
            console.log('cR');
            // table_invoices.search( table_invoices.
            // search().replace(/\s\d{4}-\d{2}/,'') );
            // table_invoices.search(table_invoices.search() + ' ' + this.value).draw();

            // var files = [];
            var kw = 0;
            var sum = 0;

            $('#column_power').html('kW');
            $('#column_payment').html('Mok.');

            $(table.rows({filter: 'applied'}).data()).each(function (i, v) {
                // console.log($(v[5]).attr('href'));
                // console.log(v[5]);
                // files[i] = $(v[5]).attr('href');
                if(JSON.parse($(v[5]).data('offer'))['offer_status_id'] > 10) {
                    kw += Number(v[5]);
                }

                // console.log($(v[6]).data());
                sum += Number($(v[6]).data('sum'));
            })
            console.log(kw);
            console.log(sum);
            $('#column_power').html($('#column_power').html() + '<br>' + kw.toFixed(2));
            $('#column_payment').html($('#column_payment').html() + '<br>' + sum.toFixed(2));

        });

        //on customer search
        table.on('search.dt', function () {
            let kw = 0;
            let sum = 0;

            const url = new URL(window.location.href);
            url.searchParams.set('filter', table.search());
            window.history.replaceState(null, null, url); // or pushState
            $('.copy_filter').text('Copy');

            $('#column_power').html('kW');
            $('#column_payment').html('Mok.');
            $(table.rows({filter: 'applied'}).data()).each(function (i, v) {
                if(  Number($(v[6]).attr('data-power')) && JSON.parse($(v[6]).attr('data-offer'))['offer_status_id'] > 10 ) {
                    kw += Number($(v[6]).attr('data-power'));
                }
                if(Number($(v[7]).attr('data-sum')) > 0){
                    sum += Number($(v[7]).attr('data-sum')) ?? 0;
                }

            })
            $('#column_power').html($('#column_power').html() + '<br><small style="white-space: nowrap">' + kw.toFixed(2) + '</small>');
            $('#column_payment').html($('#column_payment').html() + '<br><small style="white-space: nowrap">' + sum.toFixed(2) + '</small>');
        });

        // Equipment table

        // var table_eq = $('#table_eq').DataTable({
        //     "lengthMenu": [50, 150],
        //     "orderMulti": false,
        //     "autoWidth": false,
        //     "ordering": false,
        //     "stateSave": true
        // });
        // table_eq.columns.adjust().draw();
        // //on eq search
        // table_eq.on('search.dt', function () {
        //     const url = new URL(window.location.href);
        //     url.searchParams.set('filter', table_eq.search());
        //     window.history.replaceState(null, null, url); // or pushState
        //     $('.copy_filter').text('Copy');
        // });

        // Payments table

        var table_payments = $('#table_payments').DataTable({
            "lengthMenu": [50, 150],
            "orderMulti": false,
            "autoWidth": false,
            "ordering": false,
            "stateSave": true
        });

        //on payment search
        table_payments.on('search.dt', function () {
            const url = new URL(window.location.href);
            url.searchParams.set('filter', table_payments.search());
            window.history.replaceState(null, null, url); // or pushState
            $('.copy_filter').text('Copy');
        });


        // Invoices table

        var table_invoices = $('#table_invoices').DataTable({
            dom: 'lBfrtip',
            buttons: [
                'excel', 'print' // Buttons for various exports
            ],
            "lengthMenu": [100, 400],
            "orderMulti": false,
            "autoWidth": false,
            "ordering": false,
            "stateSave": true,
        });


        $('*[type="search"]')
            .addClass('input-lg')
            .css({'width': '300px', 'display': 'inline-block'});
        $('div.dataTables_filter').css({'margin-top': '1em'});


        table_invoices.columns.adjust().draw();

        //on invoices search
        table_invoices.on('search.dt', function () {
            const url = new URL(window.location.href);
            let sum_pvm = 0;

            $('#sum_pvm').html('su PVM');
            $(table_invoices.rows({filter: 'applied'}).data()).each(function (i, v) {
                if(!isNaN(parseFloat(v[5]))){
                    sum_pvm += parseFloat(v[5]);
                }
            })
            $('#sum_pvm').html($('#sum_pvm').html() + '<br><span style="white-space: nowrap; font-size: 0.8rem">' + new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(
                sum_pvm.toFixed(2)
            )  + '</span>');

            url.searchParams.set('filter', table_invoices.search());
            window.history.replaceState(null, null, url); // or pushState
            $('.copy_filter').text('Copy');
        });

        const queryString = window.location.search;
        const parameters = new URLSearchParams(queryString);
        const value = parameters.get('filter');
        if (value != undefined) {
            console.log(value);
            if (table_payments) {
                table_payments.search(value).draw();
            }
            if (table_invoices) {
                table_invoices.search(value).draw();
            }
            // if (table_eq) {
            //     table_eq.search(value).draw();
            // }
            if (table) {
                table.search(value).draw();
            }

        } else {
            if (table_payments) {
                table_payments.columns.adjust().draw();
            }
            if (table_invoices) {
                table_invoices.columns.adjust().draw();
            }
            // if (table_eq) {
            //     table_eq.columns.adjust().draw();
            // }
            if (table) {
                table.columns.adjust().draw();
            }
        }

        if (document.getElementById('calendar')) {
            require('./calendar.js');
        }

        $('.delete_customer').dblclick(function () {
            if (confirm('Ištrinti neatstatomai?')) {
                axios.post('/customer_delete/' + $(this).data('cid')).then(res => {
                    if (res.status == 203) {
                        alert(res.data);
                    } else {
                        console.log(res);
                        window.location.replace('/customers');
                    }

                })
            }

        });


        $('.custom-file-input').on('change', function () {
            console.log('sele');
            var fileName = $(this).val();
            $(this).next('.custom-file-label').addClass("border-success").html(fileName);
        });



        $('.my-filter').click(function () {
            table.search(this.value).draw();
            if (this.value == '') {
                axios.get('/full_customers').then(res => {
                    console.log(res);
                    table.row.add(
                        res.data
                    ).draw()
                });
                // table.row.add({
                //
                // }).draw()
            }
        });

        $('.my-filter-date').click(function () {
            table.search(table.search().replace(/\s\/\d{2}-\d{2}|\sGM\|\d{2}-\d{2}/, ''));
            table.search(table.search() + ' ' + this.value).draw();
        });

        $('.invoice-filter').click(function () {
            table_invoices.search(this.value).draw();
        });

        $('.invoice-filter-date').click(function () {
            table_invoices.search(table_invoices.search().replace(/\s\d{4}-\d{2}/, ''));
            table_invoices.search(table_invoices.search() + ' ' + this.value).draw();
        });

        $('.invoice-test').click(function () {
            // table_invoices.search( table_invoices.search().replace(/\s\d{4}-\d{2}/,'') );
            // table_invoices.search(table_invoices.search() + ' ' + this.value).draw();

            var files = [];

            $(table_invoices.rows({filter: 'applied'}).data()).each(function (i, v) {
                console.log($(v[6]).attr('href'));
                files[i] = $(v[6]).attr('href');

            })

            axios.post('/download/invoices', files).then(res => {
                console.log(res.data);
                window.open('storage/saskaitos_pack.zip?t=' + new Date().getTime());
            })

        });

        $('.payment-filter').click(function () {
            table_payments.search(this.value).draw();
        });

        $('.payment-filter-date').click(function () {
            table_payments.search(table_payments.search().replace(/\s\d{4}-\d{2}/, ''));
            table_payments.search(table_payments.search() + ' ' + this.value).draw();
        });

        $('.kpo-download').click(function () {
            var files = [];

            $(table_payments.rows({filter: 'applied'}).data()).each(function (i, v) {
                console.log($(v[2]).data('file'));
                files[i] = $(v[2]).data('file');

            })

            axios.post('/download/invoices', files).then(res => {
                console.log(res.data);
                window.open('storage/saskaitos_pack.zip?t=' + new Date().getTime());
            })

        });

        $('.apva_check').on('change', function () {
            console.log('apva');
            var fileName = $(this).val();
            console.log(fileName);
            let data = {};
            data.link = $(this).val();
            data.offer_id = $(this).data('offer_id');
            data.customer_id = $(this).data('customer_id');
            data.file_type_id = $(this).data('file_type_id');

            axios.post('/set_file_type', data).then(res => {
                console.log(res.data);
            })
            // $(this).next('.custom-file-label').addClass("border-success").html(fileName);
        });

        $('.forward_to_mail').click(function (e) {

            if (!$(".mail_check:checked").length) {
                alert("Nepažymėtas joks failas");
                return;
            }

            $(e.target).closest('button').attr('disabled', true);
            $(e.target).closest('button').addClass('disabled');
            $(e.target).find('span').addClass('fa-spinner');
            $(e.target).find('span').addClass('fa-spin');

            let data = {};
            let files = [];

            $(document).find('.mail_check:checked').each(function (i, v) {
                files.push(v.value);
            });

            data.files = files;
            data.cid = e.target.value;

            axios.post('/forward/files/mail', data).then(res => {
                console.log(res.data);
                alert("failai išsiųsti");
                window.location.reload();
            })
        });

        $('.payment_save').click(function (e) {
            $(e.target).closest('button').attr('disabled', true);
            $(e.target).closest('button').addClass('disabled');
            $(e.target).find('span').addClass('fa-spinner');
            $(e.target).find('span').addClass('fa-spin');
            console.log(
                $(e.target).closest('.form-row').find('#payment_amount').val(),
                $(e.target).closest('.form-row').find('#payment_source').val(),
                $(e.target).closest('.form-row').find('#payment_date').val()
            );
            // return;
            if (confirm('Saugoti gautą mokėjimą?')) {
                var data = {};
                data.amount = Number($(e.target).closest('.form-row').find('#payment_amount').val());
                data.source = Number($(e.target).closest('.form-row').find('#payment_source').val());
                data.date = $(e.target).closest('.form-row').find('#payment_date').val();
                if (data.amount <= 0) {
                    return;
                }
                data.offer_id = $(e.target).closest('.form-row').find('#payment_amount').data('offer');
                if (data.offer_id == 'sale') {
                    data.offer_id = null;
                    data.sale_id = $(e.target).closest('.form-row').find('#payment_amount').data('sale');
                }
                axios.post('/payment', data).then(res => {
                    console.log(res.data);
                    if (res.data === 'OK') {
                        console.log('reload');
                        window.location.reload();
                    }
                })
                    .catch(function (error) {
                        console.log(error.response);
                        alert(error.response.data.message);
                        return error.response;
                    })
            }
        });

        $('.full_customers_btn').click(function (e) {
            e.target.innerHTML = e.target.innerHTML + ' <span class="fa fa-spinner fa-spin"></span> ';
            $(e.target).attr('disabled', 'disabled').addClass('disabled');
        });

        $('.confirm_offer_edit').click(function (event) {
            event.preventDefault();
            if(confirm('Pakeitus pasliūlymo duomenis, anksčiau sugeneruoti dokumentai gali būti klaidingi! Tęsti?')){
                window.location.href =$(event.target).attr("href")
            }
        })

        setTimeout(function () {
            $('body').removeClass('preloading')
        }, 500);
        setTimeout(function () {
            $('body').addClass('loaded')
        }, 500);
        setTimeout(function () {
            $('body').removeClass('loaded')
        }, 800);


    },
    methods: {
        vue_edit(e) {
            $(e.target).removeAttr('readonly');
            let obj = e.target;
            $(e.target).keydown(function (e) {
                if (e.keyCode === 13) {
                    let map = $(e.target).data('map').split('|');
                    map[4] = $(e.target).val();
                    console.log(map);
                    axios.post('/ajax_update', map).then(res => {
                        if (res.data === 'OK') {
                            $(obj).attr('readonly', 'readonly');
                        }
                    })
                }
            });


        },
        delete_file(e) {
            var data = {};
            console.log($(e.target).prop('id'));
            data.file = $(e.target).prop('id');
            if (confirm('Trinti?')) {
                axios.post('/delete_file', data).then(res => {
                    console.log(res.data);
                    $(e.target).closest(".card-body").remove();
                })
            }

        },

        offer_done(e) {
            let map = [];
            map[0] = 'offers';
            map[1] = 'id';
            map[2] = $(e.target).data('oid');
            map[3] = 'offer_status_id';
            map[4] = 10;
            console.log(map);

            axios.get('/get_pdfs/' + map[2]).then(res => {
                if (res.data === 1) {
                    axios.post('/ajax_update', map).then(res => {
                        if (res.data === 'OK') {
                            window.location.reload();

                        }
                    })
                } else {
                    $(e.target).addClass('text-danger');
                    alert('Dar nesugeneruoti dokumentai');
                }
            })


        }


    }
});
